import Calendar from 'react-calendar'

const CalendarComponent = () => {
    return (
        <div>
            <Calendar />
        </div>
    )
}

export default CalendarComponent
